<div class="tost-message-container">
  <span class="toster-message" matSnackBarLabel>
    {{ data.message }}
  </span>
  <span matSnackBarActions>
    <button matButton matSnackBarAction (click)="snackBarRef.dismissWithAction()">✕</button>
  </span>
</div>